module.exports = __webpack_public_path__ + "static/media/Data_insight_en_3-2.d1e856bf.svg";